"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const input_1 = require("./input");
var Model;
(function (Model) {
    let ColumnType;
    (function (ColumnType) {
        ColumnType["Uuid"] = "Uuid";
        ColumnType["String"] = "String";
        ColumnType["Int"] = "Integer";
        ColumnType["Double"] = "Double";
        ColumnType["Bool"] = "Bool";
        ColumnType["Enum"] = "Enum";
        ColumnType["DateTime"] = "DateTime";
        ColumnType["Date"] = "Date";
    })(ColumnType = Model.ColumnType || (Model.ColumnType = {}));
    let RelationType;
    (function (RelationType) {
        RelationType["OneHasOne"] = "OneHasOne";
        RelationType["OneHasMany"] = "OneHasMany";
        RelationType["ManyHasOne"] = "ManyHasOne";
        RelationType["ManyHasMany"] = "ManyHasMany";
    })(RelationType = Model.RelationType || (Model.RelationType = {}));
    let OnDelete;
    (function (OnDelete) {
        OnDelete["cascade"] = "cascade";
        OnDelete["restrict"] = "restrict";
        OnDelete["setNull"] = "set null";
    })(OnDelete = Model.OnDelete || (Model.OnDelete = {}));
    Model.OrderDirection = input_1.default.OrderDirection;
})(Model || (Model = {}));
exports.default = Model;
//# sourceMappingURL=model.js.map